import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import SentryManager from '@widgets/sentry-manager';
SentryManager.init();

import initWidgets from '@widgets';
import logger from '@widgets/logger';

initWidgets();
// import reportWebVitals from 'reportWebVitals';

import App from 'App';
import { store } from 'store';
import './index.css';

function AppWithCallbackAfterRender() {
    useEffect(() => {
        logger.success('Pluspoint rendered');
    });

    return (
        <Provider store={store}>
            <App />
        </Provider>
    );
}

const container = document.getElementById('app');
const root = createRoot(container);
root.render(<AppWithCallbackAfterRender />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))

// reportWebVitals();
